import { render, staticRenderFns } from "./AppSaveBar.vue?vue&type=template&id=0cf06392&"
import script from "./AppSaveBar.vue?vue&type=script&lang=js&"
export * from "./AppSaveBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports